/**
 * Deep clones an object.
 * @param obj
 */
export function clone<T>(obj): T {
  return <T>JSON.parse(JSON.stringify(obj));
}
